export function isEqual(a, b) {
    if (a === b) return true;

    if (a && b && typeof a === 'object' && typeof b === 'object') {
        if (Array.isArray(a) !== Array.isArray(b)) return false;

        const keys = Object.keys(a);
        if (keys.length !== Object.keys(b).length) return false;

        return keys.every(key => isEqual(a[key], b[key]));
    }
    return false;
}
